export default __webpack_public_path__ + "static/hcs-text-logo-white-acceb6a2816ca30e35dbe53c4c6ada06.svg";